import React, { useEffect, useState } from 'react';
import { CheckboxControl, DialogControl, FieldControl } from 'spark-core-dx/components';
import { useDashboardDomainContext } from '../../DashboardDomainProvider';
import { useValidationErrors } from 'spark-core-dx/hooks';
import { SystemTypes } from 'spark-core-dx/services';

const emptyPage = {
  Key: "",
  Name: "",
  Description: "",
  Icon: "",
  ColumnCount: 10,
  IsDefault: false,
};

const DashboardPageDialog = ({ isActive, closeDialog, page, onSave }) => {
  const { iconSelectData } = useDashboardDomainContext();
  const { hasAndShowValidationErrors } = useValidationErrors();
  const [pageState, setPageState] = useState(emptyPage);

  useEffect(() => {
    setPageState(page ? {
      Key: page.Key ?? "",
      Name: page.Name ?? "",
      Description: page.Description ?? "",
      Icon: page.Icon ?? "",
      ColumnCount: Number(page.ColumnCount) || 10,
      IsDefault: !!page.IsDefault,
    } : emptyPage);
  }, [page, isActive]);

  return (
    <DialogControl
      className="dashboard-dialog"
      openDialog={isActive}
      title={page ? "Edit Page" : "Create Page"}
      okText={page ? "Save" : "Create"}
      disableOk={!pageState.Name.trim() || !pageState.Key.trim()}
      onCancel={closeDialog}
      onOk={async () => {
        if (!hasAndShowValidationErrors("dashboard-page")) {
          const success = await onSave?.(pageState);
          if (success !== false) {
            closeDialog();
          }
        }
      }}
    >
      <div className="dialog-text">
        <FieldControl
          fieldMetadata={{
            FieldType: SystemTypes.UIFieldType.TextBox,
            IsRequired: true,
            FieldName: "PageName",
            DisplayName: "Page Name",
          }}
          groupId="dashboard-page"
          value={pageState.Name}
          onChange={(value) => setPageState((prev) => ({ ...prev, Name: value }))}
        />
        <FieldControl
          fieldMetadata={{
            FieldType: SystemTypes.UIFieldType.TextBox,
            IsRequired: true,
            FieldName: "PageKey",
            DisplayName: "Page Key",
          }}
          groupId="dashboard-page"
          value={pageState.Key}
          onChange={(value) => setPageState((prev) => ({ ...prev, Key: value }))}
        />
        <FieldControl
          fieldMetadata={{
            FieldType: SystemTypes.UIFieldType.TextBox,
            FieldName: "PageDescription",
            DisplayName: "Page Description",
          }}
          groupId="dashboard-page"
          value={pageState.Description}
          onChange={(value) => setPageState((prev) => ({ ...prev, Description: value }))}
        />
        <FieldControl
          fieldMetadata={{
            FieldType: SystemTypes.UIFieldType.IconSelect,
            FieldName: "PageIcon",
            DisplayName: "Page Icon",
            DataJson: iconSelectData,
          }}
          groupId="dashboard-page"
          value={pageState.Icon}
          onChange={(value) => setPageState((prev) => ({ ...prev, Icon: value }))}
        />
        <FieldControl
          fieldMetadata={{
            FieldType: SystemTypes.UIFieldType.SearchSelectList,
            FieldName: "PageColumns",
            DisplayName: "Grid Columns",
            DataJson: Array.from({ length: 14 }, (_, index) => ({
              Text: String(index + 2),
              Value: index + 2,
            })),
          }}
          groupId="dashboard-page"
          value={pageState.ColumnCount}
          onChange={(value) => setPageState((prev) => ({ ...prev, ColumnCount: Number(value) }))}
        />
        <div className="checkbox">
          <CheckboxControl
            value={pageState.IsDefault}
            onChange={() => setPageState((prev) => ({ ...prev, IsDefault: !prev.IsDefault }))}
          />
          Set as default page
        </div>
      </div>
    </DialogControl>
  );
};

export default DashboardPageDialog;
